import React from 'react';
import PropTypes from 'prop-types';
import { LuArrowDownWideNarrow, LuArrowUpWideNarrow, LuListTodo, LuPlus } from 'react-icons/lu';
import PageHero from '../../../components/data/PageHero';
import Button from '../../../components/ui/Button';
import useTodoText from '../todoText';
import { SORT_KEYS } from '../todoColumns';

/** Title card of Yapılacaklar Listesi; "Yeni Görev" for admins. */
const TodoHeader = ({ isAdmin, onAdd }) => {
  const { label } = useTodoText();
  return (
    <PageHero
      icon={LuListTodo}
      gradient="tw-from-teal-400 tw-to-cyan-600 tw-shadow-teal-500/30"
      title={label('page.title')}
      subtitle={label('page.subtitle')}
      actionsClassName="tw-flex tw-items-center tw-gap-2 max-sm:tw-w-full"
    >
      {isAdmin && (
        <Button variant="primary" onClick={onAdd} className="max-sm:tw-w-full">
          <LuPlus aria-hidden="true" className="tw-h-4 tw-w-4" strokeWidth={2.5} />
          {label('actions.add')}
        </Button>
      )}
    </PageHero>
  );
};

TodoHeader.propTypes = { isAdmin: PropTypes.bool, onAdd: PropTypes.func.isRequired };

/** Sort field + direction, as a pill in the toolbar (the old sortable headers). */
export const SortControl = ({ sortConfig, onChange }) => {
  const { label } = useTodoText();
  const Icon = sortConfig.direction === 'asc' ? LuArrowUpWideNarrow : LuArrowDownWideNarrow;
  return (
    <span className="tw-inline-flex tw-h-8 tw-items-center tw-overflow-hidden tw-rounded-full tw-border tw-border-slate-200 tw-bg-white/60 tw-text-xs tw-font-semibold tw-text-slate-600 dark:tw-border-white/10 dark:tw-bg-white/[0.04] dark:tw-text-slate-300">
      <label className="tw-flex tw-h-full tw-items-center tw-gap-1 tw-pl-3">
        <span>{label('toolbar.sort')}:</span>
        <select
          value={sortConfig.key}
          onChange={(event) => onChange({ ...sortConfig, key: event.target.value })}
          className="tw-h-full tw-cursor-pointer tw-appearance-none tw-border-0 tw-bg-transparent tw-pr-1 tw-text-xs tw-font-semibold tw-text-slate-800 tw-shadow-none tw-outline-none focus-visible:tw-underline dark:tw-text-slate-100"
        >
          {SORT_KEYS.map((key) => <option key={key} value={key}>{label(`toolbar.sortBy.${key}`)}</option>)}
        </select>
      </label>
      <button
        type="button"
        onClick={() => onChange({ ...sortConfig, direction: sortConfig.direction === 'asc' ? 'desc' : 'asc' })}
        title={sortConfig.direction === 'asc' ? label('toolbar.asc') : label('toolbar.desc')}
        aria-label={sortConfig.direction === 'asc' ? label('toolbar.asc') : label('toolbar.desc')}
        className="tw-grid tw-h-full tw-w-8 tw-place-items-center tw-border-l tw-border-slate-200 tw-bg-transparent hover:tw-bg-white hover:tw-text-slate-900 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-inset focus-visible:tw-ring-teal-500/50 dark:tw-border-white/10 dark:hover:tw-bg-white/[0.08] dark:hover:tw-text-white"
      >
        <Icon aria-hidden="true" className="tw-h-3.5 tw-w-3.5" />
      </button>
    </span>
  );
};

SortControl.propTypes = {
  sortConfig: PropTypes.shape({ key: PropTypes.string, direction: PropTypes.string }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TodoHeader;
